/**
 * Staff Listing Block - Read More Functionality
 */

(function($) {
    'use strict';
    
    function initStaffListing() {
        $('.block-staff__card-read-more').off('click.staffListing').on('click.staffListing', function(e) {
            e.preventDefault();
            
            const $button = $(this);
            const $card = $button.closest('.block-staff__card');
            const $additionalInfo = $card.find('.block-staff__card-additional-info');
            const isExpanded = $button.attr('aria-expanded') === 'true';
            
            if (isExpanded) {
                // Collapse
                $additionalInfo.slideUp(300, function() {
                    $button.attr('aria-expanded', 'false');
                });
            } else {
                // Expand
                $button.attr('aria-expanded', 'true');
                $additionalInfo.slideDown(300);
            }
        });
    }
    
    // Initialize on document ready
    $(document).ready(function() {
        initStaffListing();
    });
    
    // Re-initialize when new content is loaded (for dynamic content)
    $(document).on('DOMContentLoaded', function() {
        initStaffListing();
    });
    
    // Support for Gutenberg editor preview
    if (typeof wp !== 'undefined' && wp.data) {
        wp.data.subscribe(function() {
            setTimeout(initStaffListing, 100);
        });
    }
    
})(jQuery);